import { Container } from '@doist/marketist';
import cn from 'clsx';
import { MainPageHeader } from 'components/main-page-header/main-page-header';
import { useTranslation } from 'next-i18next';
import SearchBar from '../../search-bar/search-bar';
import css from './intro-section.module.css';
export default function IntroSection() {
  const {
    t
  } = useTranslation('helpcenter');
  return <Container className={css.introSection} tag="section" padded data-sentry-element="Container" data-sentry-component="IntroSection" data-sentry-source-file="intro-section.tsx">
            <MainPageHeader title={t('intro.title')} padded={false} style={{
      '--top-padding': '0'
    }} data-sentry-element="MainPageHeader" data-sentry-source-file="intro-section.tsx" />
            <SearchBar className={cn(css.searchBar, 'mbe-48 md-mbe-64')} title={t('search')} data-sentry-element="SearchBar" data-sentry-source-file="intro-section.tsx" />
        </Container>;
}